import axios from 'axios';
import { store } from '@/scripts/store';
import { getSkewTime, queryParamsToString, tips } from '@/scripts/tools/utils';

// 调整时间后发送请求
/**
 * 请求 oauth 接口
 * @param {String} api 请求接口
 * @param {String} method 请求方法
 * @param {Object} data 发送数据
 */
const sendRequest = function sendRequest(api, method, data, isCos5) {
  const url = `${isCos5 ? store.cos5ServerPrefix : `${store.cosbrowserServerUrl}/`}api/oauth/`;
  const reqOpt = {
    method,
    url: `${url}${api}`,
  };
  if (method !== 'GET') {
    Object.assign(reqOpt, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data: queryParamsToString(data),
    });
  }
  return axios(reqOpt);
};

/**
 * oauth 相关接口
 */
const oauthApi = {
  handShake() {
    return sendRequest('handShake', 'GET');
  },
  check(params) {
    return sendRequest('check', 'POST', params, true);
  },
  clientToken(params) {
    return sendRequest('token', 'POST', params);
  },
  getCredential(params) {
    const timestamp = Math.floor(getSkewTime() / 1000);
    params.timestamp = timestamp;
    return sendRequest('credential', 'POST', params);
  },
};

const api = {
  clientId: '',
  clientCode: '',
  clientToken: '',
  authCode: '',
  userOpenId: '',
  /**
   * 获取腾讯云登录信息
   */
  async getCloudLoginUrl() {
    try {
      const { clientId, clientCode } = await oauthApi.handShake();
      this.clientId = clientId;
      this.clientCode = clientCode;
      // eslint-disable-next-line max-len
      const redirectUrl = `${store.oauthPrefix}oauth.html?client_id=${clientId}&client_code=${clientCode}&from=web&tokenMode=2&officialDomain=${store.officialDomain}`;
      // eslint-disable-next-line max-len
      const jumpPathname = store.officialDomain.endsWith('.tencentcloud.com') ? '/account/open/authorize' : '/open/authorize';
      // eslint-disable-next-line max-len
      const url = `https://${store.officialDomain}${jumpPathname}?scope=login&app_id=100015535367&redirect_url=${encodeURIComponent(redirectUrl)}`;
      return url;
    } catch (error) {
      console.log('getCloudLoginUrl -> error', error);
      tips.closeTips();
      // TODO: 中英文翻译
      const msg = (error && error.message) || error;
      tips.error(`登录失败,${msg}`);
      return '';
    }
  },
  /**
   * 检查登录状态，获取 oauth 所需登录信息
   */
  async getLoginInfo() {
    const { clientId, clientCode, authCode } = this;
    try {
      if (authCode) {
        const { clientToken, userOpenId } = await oauthApi.clientToken({ clientId, clientCode, authCode });
        return { clientId, clientToken, userOpenId };
      }
      const { clientToken, userOpenId } = await oauthApi.check({ clientId, clientCode });
      return { clientId, clientToken, userOpenId };
    } catch (error) {
      tips.closeTips();
      // TODO: 中英文翻译
      // tips.error(`登录失败,${error.message}`);
      return {};
    }
  },
  async getCredential(params) {
    try {
      // bindingSig / bindingExpireAt：接入层 validate-oauth-binding 中间件下发的内部凭证。
      // 后端可能不返回（兼容期 / 派发失败兜底），下游会兼容 undefined。
      const {
        credentials, token, expiredTime, bindingSig, bindingExpireAt,
      } = await oauthApi.getCredential(params);
      return {
        credentials, token, expiredTime, bindingSig, bindingExpireAt,
      };
    } catch (error) {
      // 登录过期
      if (error) {
        if (error.code === -3) {
          tips.closeTips();
          // TODO: 中英文翻译
          tips.error('登录已过期，请重新登录。');
        } else {
          tips.closeTips();
          tips.error(error.message);
        }
      }
      return {};
    }
  },
};

export default api;
